// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import BreadcrumbsPresentationPropsDefault from "@insite/mobius/Breadcrumbs/presentationProps";
import { xBaseTheme } from "@mcmc/XDL/types";
import { css } from "styled-components";

export default {
    defaultProps: {
        typographyProps: {
            size: "12px",
            lineHeight: "14px",
            transform: "uppercase",
            weight: 400,
            css: css`
                letter-spacing: 0.86px;
            `,
        },
        css: css`
            flex-wrap: wrap;
            margin-right: auto;
            @media print {
                display: none;
            }
        `,
    },
} as xBaseTheme["breadcrumbs"];
